import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import LoginModal from "./LoginModal";
import { useAuth } from "../AuthContext";

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);

  // Si se loguea, cerramos el modal automáticamente
  useEffect(() => {
    if (isAuthenticated) setOpen(false);
  }, [isAuthenticated]);

  const api = useMemo(
    () => ({
      loginOpen: open,
      openLogin: () => setOpen(true),
      closeLogin: () => setOpen(false),
    }),
    [open]
  );

  return (
    <LoginModalContext.Provider value={api}>
      {children}
      <LoginModal open={open} onClose={() => setOpen(false)} />
    </LoginModalContext.Provider>
  );
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext);
  if (!ctx) throw new Error("useLoginModal debe usarse dentro de <LoginModalProvider />");
  return ctx;
}
